import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconListBullet32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconListBullet32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M7.5 8A1.25 1.25 0 1 1 5 8a1.25 1.25 0 0 1 2.5 0m18.576 1a1 1 0 1 0 0-2H10.424a1 1 0 1 0 0 2zm0 10a1 1 0 1 0 0-2H10.424a1 1 0 1 0 0 2zm-1.762-6a1 1 0 0 1-1 1h-12.89a1 1 0 0 1 0-2h12.89a1 1 0 0 1 1 1m-1 11a1 1 0 1 0 0-2h-12.89a1 1 0 0 0 0 2zM6.25 14.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M7.5 18A1.25 1.25 0 1 1 5 18a1.25 1.25 0 0 1 2.5 0m-1.25 6.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconListBullet32);
